import React from "react"
import {useCurrentRefinements} from "react-instantsearch"
import ClearFilters from "@bodeboca/algolia/components/filters/clear-filters"
import {useTranslation} from "react-i18next"
import CommonUtils from "@bodeboca/utils"
import ApiService from "@bodeboca/api"

type Props = {
  excludedAttributes?: string[];
};
const FiltersApplied = ({
  excludedAttributes = ["price", "query"],
}: Props) => {
  const {t} = useTranslation()
  const {items, refine} = useCurrentRefinements({
    excludedAttributes: excludedAttributes,
  })

  const getLabel = (attribute, label): string => {
    let data = ApiService.getItemFromId(attribute, label)
    return data.label
  }

  return (<>
    {items.length > 0 && <div>
      <h4 className="filter-by-prefix-title">{t('Applied filters')}</h4>
      <div className="filter-by-prefix-after"></div>
      {items.map((item) => (<div
        key={[ApiService.getDefaultIndex(), item.label, item.value, 'parent'].join('/')}>
        {item.refinements.map((refinement) => (<div
          className="bb-filter-control-selected"
          key={[ApiService.getDefaultIndex(), refinement.label, item.value].join('/')}>
          <span
            className="bb-filter-control">
            {getLabel(refinement.attribute, refinement.label)}
          </span>
          <div
            className="bb-filter-control-unset"
            onClick={() => {
              refine(refinement)
              CommonUtils.hideFilters()
            }}>
            ×
          </div>
        </div>))}
      </div>))}
      <ClearFilters/>
    </div>}
  </>)
}
export default FiltersApplied
